import PDFPageViewer from './PDFPageViewer';
import SupportEmail from "../components/SupportEmail";

const IntellectualProperty = () => {
  const pdfUrl = "https://omegavoid.com/documents/Omega_Void_Provisional_Patent.pdf";

  return (
    <>
      <div className="ip-container">
        <h1>Intellectual Property & Cyber Crime Protection</h1>

        <div className="legal-disclaimer">
          <div className="disclaimer-header">
            <div className="disclaimer-icon"></div>
            <h2>Legal Notice</h2>
          </div>
          <p>
            <strong>PATENT PENDING.</strong> Certain technologies and methods associated with
            Omega Void&reg; are the subject of pending patent protection.
          </p>
        </div>

        <div className="ip-introduction">
          <p>
            Omega Ops Tech, a registered business name of Omega Ops Cybernetics Defence Corp.,
            develops decentralized cyber-defence and secure communications technology.
          </p>
        </div>

        <div className="patent-section">
          <h2>Patent Pending</h2>

          <div className="patent-item">
            <div className="patent-header">
              <h3>Omega Void</h3>
              <span className="patent-status">Patent Pending</span>
            </div>

            <div className="patent-content">
              <PDFPageViewer pdfUrl={pdfUrl} loadingText="Loading patent document..." />

              <div className="patent-description">
                <p>
                  Our flagship decentralized visual cyber-defence messaging platform.
                  The Omega Void system provides security through distributed
                  authentication protocols and zero-knowledge architecture.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SupportEmail />
    </>
  );
};

export default IntellectualProperty;
